import React from "react";
import { Modal } from "react-bootstrap";
import cogoToast from "cogo-toast";
import { useDemoteUserMutation } from "../../../../../redux/apiSlice";

const DemoteUserModal = ({ showDemoteUserModal, onHide, details }) => {
  const [demoteUser, { isLoading: isUpdating }] = useDemoteUserMutation();

  const handleDemote = () => {
    const data = {
        userId: details?.userId,
        createdAt: details?.createdAt,
        profileId: details?.profileId,
        socialProvider: details?.socialProvider,
        suspensionDurationInDays: details?.suspensionDurationInDays,
        userGroup: details?.userGroup,
    };

    demoteUser(data)
      .unwrap()
      .then(() => {
        cogoToast.success("Demote User Action Created Successfully");
        onHide();
      })
      .catch(() => {
        cogoToast.error("Failed to demote user");
      });
  };

  return (
    <Modal
      show={showDemoteUserModal}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      backdrop={isUpdating ? "static" : true}
      keyboard={!isUpdating}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">Demote User</Modal.Title>
        <button type="button" className="close" onClick={onHide}>
          <span aria-hidden="true" className="d-block">×</span>
          <span className="sr-only">Close</span>
        </button>
      </Modal.Header>

      <Modal.Body
        style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}
      >
        Are you sure you want to demote <strong>{details.username}</strong>?
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          onClick={onHide}
          className="btn btn-light btn-elevate px-4"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={handleDemote}
          className="btn btn-primary btn-elevate px-4 ml-4"
          disabled={isUpdating}
        >
          Demote
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DemoteUserModal;
